<style lang="less">
.img-captcha {
  position: fixed;
  z-index: 10;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  .img-captcha-layer {
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.3);
    position: absolute;
  }
  .img-captcha-wrap {
    height: 184px;
    width: 280px;
    margin: auto;
    margin-top: 30%;
    border-radius: 3px;
    position: relative;
    background: #fff;
    .img-captcha-title {
      font-size: 16px;
      padding: 18px 0;
      text-align: center;
    }
    .img-captcha-content {
      height: 50px;
      margin: 0 15px 25px 15px;
      border-bottom: .5px rgb(237, 237, 237) solid;
      background-color: #fff;
      position: relative;

      input {
        height: 22px;
        margin: 14px 0;
        width: 100%;
        font-size: 15px;
        color: rgb(189, 192, 197);
        border: 0;
        outline-width: 0;
      }
      .ic-pic {
        height: 40px;
        width: 85px;
        position: absolute;
        right: 0;
        top: 5px;
      }
    }
    .img-captcha-op {
      width: 100%;
      height: 50px;
      margin: 0 auto;
      text-align: center;
      font-size: 15px;
      line-height: 50px;
      border-top: solid 1px #ccc;
      .img-captcha-cancel {
        width: 49%;
        height: 100%;
        float: left;
        border-right: solid 1px #ccc;
      }
      .img-captcha-confirm {
        width: 49%;
        height: 100%;
        float: left;
        color: red
      }
    }
  }
}

</style>

<template>
  <div class="img-captcha">
    <div class="img-captcha-layer"></div>
    <div class="img-captcha-wrap">
      <div class="img-captcha-title">提示</div>
      <div class="img-captcha-content">
        <input type="text" placeholder="请输入图形验证码" v-model="imgCaptchaCode">
        <img :src="imgAddress" alt="" class="ic-pic" @click="changeImgCaptcha">
      </div>
      <div class="img-captcha-op">
        <div class="img-captcha-cancel" @click="onCancel">取消</div>
        <div class="img-captcha-confirm" @click="onConfirm">确认</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['imgAddress'],
    data() {
      return {
        data: 'test',
        imgCaptchaCode: ''
      }
    },
    methods: {
      changeImgCaptcha: function () {
        this.$emit('imgCaptchaCodeGet')
      },
      onCancel: function () {
        this.$emit('imgCaptchaCodeCancel')
        this.imgCaptchaCode = ''
      },
      onConfirm: function () {
        this.$emit('imgCaptchaCodeConfirm', {
          imgCaptchaCode: this.imgCaptchaCode
        })
        this.imgCaptchaCode = ''
      }
    },
  }
</script>
